/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';
import Layout from './Layout';
import { HeroAnalysis } from './HeroSections';
import { AnalysisOverview } from './PageSections';
import Clients from './Clients';
import { ServicesAnalysis } from './Services';
import Testimonials from './Testimonials';
import Contact from './Contact';

interface PageProps { user: string | null; }

const AnalysisPage = ({ user }: PageProps) => (
  <Layout user={user}>
    <HeroAnalysis />
    <AnalysisOverview />
    <Clients />
    <ServicesAnalysis />
    <Testimonials />
    <Contact />
  </Layout>
);

export default AnalysisPage;
